import storage from './storage'


const api = {
  'localhost:8080': 'http://super-monitor-test.chainopen.cn/',  // 测试
  'localhost:8080': 'http://super-monitor-test.chainopen.cn/',  // 测试

  //'localhost:8083': 'http://192.168.99.138:9999',  // 测试
   'localhost:8082': 'http://super-monitor-test.chainopen.cn/',  // 测试
  'localhost:8081': 'http://super-monitor-test.chainopen.cn/',  // 测试
  'localhost:8083': 'http://super-monitor-test.chainopen.cn/',  // 测试
  'localhost:8085': 'http://super-monitor-test.chainopen.cn/',  // 测试
  'localhost:8084': 'http://super-monitor-test.chainopen.cn/',  // 测试
  // 'localhost:8082': 'http://super-monitor-test.chainopen.cn/',  // 测试
  // 'localhost:8081': 'http://super-monitor.chainopen.cn',   // 生产
  'localhost:8081': 'http://super-monitor-test.chainopen.cn/',   // 测试
}

export function getAppBaseUrl() {
  return storage.temp('session','baseUrl') || api[location.host] || location.protocol + '//' + location.host
}
export function getEnv() {
  let baseUrl = getAppBaseUrl();
  if (baseUrl.includes('test')) {
    return 'dev'
  }
  return 'pro'
}
const contractApi = {
  'localhost:8081': 'http://baas-test.chainopen.cn/node',  // 测试
  //'localhost:8081': 'http://super-monitor.chainopen.cn',   // 生产
}
export function getContractBaseUrl() {
  return storage.temp('session','baseUrl') || contractApi[location.host] || location.protocol + '//' + location.host + '/node'
}

